/**
 * 관리자 캐시 현황
 * ($j.Pages.Admin.CashCurrent / body data-page-name="CashCurrent")
 *
 * 회원·지사 보유캐시 + 당월 회비 납부경로(pay_history) + 회원 랭킹(누적회비·캐시 입출금/보유).
 */
import Util from '../../Common/Util';

export default class CashCurrent {
    constructor() {
        this.palette = ['#0d6efd', '#198754', '#fd7e14', '#6610f2', '#20a8a8', '#dc3545'];
        this.$feeTable = null;
        this.$flowTable = null;
        this.$payMemTable = null;
        this.top = null;          // 랭킹 응답 캐시 (지표 전환 시 재조회 안 함)
    }

    initialize() {
        $('#ccRefresh').on('click', () => this._loadAll(true));
        // 막대는 로드 후에 그려지므로 위임으로 받는다
        $('#ccBySource').on('click', '.row-item', (e) => this._openPayMembers($(e.currentTarget)));
        this._loadAll();
    }

    _loadAll(nocache = false) {
        this._load(nocache);
        this._loadTop(nocache);
    }

    async _load(nocache = false) {
        try {
            const res = await $.ajax({
                url: '/adm/ajax/stat/cash/current', type: 'get',
                data: nocache ? { nocache: 1 } : {}
            });
            if (!res.ok) return;
            $('#ccMemberCash').text(this._won(res.member_cash));
            $('#ccMemberCashSub').text(`${this._c(res.member_cash_owners)}명 보유`);
            $('#ccGisaCash').text(this._won(res.gisa_cash));
            $('#ccPaid').text(this._c(res.paid_total));
            $('#ccExempt').text(`감면·면제 ${this._c(res.exempt)}명`);
            $('#ccExpected').text(this._won(res.fee_expected));
            this._bars('#ccBySource', res.by_source);
            if (res.cached_at) $('#ccCachedAt').text(`집계 ${res.cached_at}`);
        } catch (e) {
            console.error('캐시 현황 로드 실패', e);
        }
    }

    /** 회원 랭킹 — 누적회비 TOP N + 캐시 TOP N (지표 3종을 한 번에 받아둔다) */
    async _loadTop(nocache = false) {
        try {
            const res = await $.ajax({
                url: '/adm/ajax/stat/cash/top', type: 'get',
                data: nocache ? { nocache: 1 } : {}
            });
            if (!res.ok) return;
            this.top = res;
            $('#ccFeeLimit,#ccFlowLimit').text(this._c(res.limit));
            this._renderFeeTable(res.fee || []);
            this._renderFlowTable();
        } catch (e) {
            console.error('캐시 회원 랭킹 로드 실패', e);
        }
    }

    _renderFeeTable(rows) {
        if (this.$feeTable) { this.$feeTable.destroy(); $('#ccFeeTable').empty(); this.$feeTable = null; }

        this.$feeTable = new DataTable('#ccFeeTable', {
            data: rows,
            columns: [
                { data: 'rank', title: '#', className: 'rk' },
                { data: 'mem_name', title: '이름', render: (v, t, r) => this._nameCell(v, r) },
                { data: 'mem_car_type', title: '장비', render: (v) => Util.escapeHtml(v || '-') },
                { data: 'amount', title: '누적 회비', className: 'num', render: (v) => this._c(v) },
                { data: 'months', title: '납부월수', className: 'num', render: (v) => this._c(v) },
                { data: 'last_month', title: '최근 납부월', className: 'num', render: (v) => this._fmtMonth(v) },
            ],
            order: [],              // 서버 랭킹 순서 유지
            columnDefs: [{ targets: '_all', orderSequence: ['desc', 'asc'] }],   // 첫 클릭 = 큰 값부터
            pageLength: 25,
            lengthChange: false,
            searching: true,
            info: false,
            autoWidth: false,
            language: { emptyTable: '없음', search: '검색:', zeroRecords: '없음' },
        });
    }

    /**
     * 캐시 목록 — 지표 토글 없이 한 표다. 각 열을 클릭해 정렬한다.
     * 서버가 각 지표 상위의 합집합을 주므로 어느 열로 정렬해도 그 열의 상위가 들어 있다.
     * 순번(#)은 두지 않는다 — 정렬을 바꾸면 뜻이 없어진다.
     */
    _renderFlowTable() {
        if (!this.top) return;
        if (this.$flowTable) { this.$flowTable.destroy(); $('#ccFlowTable').empty(); this.$flowTable = null; }

        const rows = this.top.flow || [];
        $('#ccFlowCount').text(this._c(rows.length));

        const cash = (key, title) => ({ data: key, title, className: 'num', render: (v) => this._c(v) });

        this.$flowTable = new DataTable('#ccFlowTable', {
            data: rows,
            columns: [
                { data: 'mem_name', title: '이름', render: (v, t, r) => this._nameCell(v, r) },
                cash('deposit', '누적입금'),
                cash('withdraw', '누적출금'),
                {
                    data: 'fee_pl', title: '수수료 손익', className: 'num',
                    // 발주자는 받고(+) 수주자는 낸다(−). 부호가 뜻이라 색으로 가른다.
                    render: (v) => {
                        const n = Number(v) || 0;
                        if (n === 0) return '0';
                        const color = n > 0 ? '#0d6efd' : '#dc3545';
                        return `<span style="color:${color}">${this._c(n)}</span>`;
                    },
                },
                cash('balance', '현재보유'),
            ],
            order: [[4, 'desc']],   // 기본은 현재보유 큰 순
            // 열을 누르면 **큰 값부터** 나온다. 금액표에서 첫 클릭이 오름차순이면
            // 0원짜리가 먼저 나와 매번 한 번 더 눌러야 한다(DataTables 기본이 asc).
            columnDefs: [{ targets: '_all', orderSequence: ['desc', 'asc'] }],
            pageLength: 25,
            lengthChange: false,
            searching: true,
            info: true,
            autoWidth: false,
            language: {
                emptyTable: '없음', search: '검색:', zeroRecords: '없음',
                info: '총 _TOTAL_명', infoEmpty: '', infoFiltered: '(전체 _MAX_명 중)',
            },
        });
    }

    /**
     * 이름 셀 — 관리자 회원 표기(`이름#번호` + 회원 팝오버) + 탈퇴회원 표시.
     */
    _nameCell(v, r) {
        const left = Number(r.mem_status) >= 98 ? ' <span class="badge badge-secondary">탈퇴</span>' : '';
        return $j.F.Admin.Member.Pop.cell(r.mb_no, v) + left;
    }

    _bars(sel, items) {
        if (!items || !items.length) { $(sel).html('<span class="text-muted small">없음</span>'); return; }
        const total = items.reduce((a, b) => a + b.count, 0);
        const max = Math.max(...items.map(i => i.count));
        const html = items.map((i, idx) => {
            const w = max > 0 ? Math.round(i.count / max * 100) : 0;
            const pct = total > 0 ? Math.round(i.count / total * 100) : 0;
            const exempt = i.paid === 0 ? ' <span class="text-muted">(무상)</span>' : '';
            return `<div class="row-item" data-source="${i.source || ''}" data-label="${i.label}" title="회원목록 보기">
                <span class="lbl">${i.label}</span>
                <span class="bar" style="width:${Math.max(w, 3)}%;background:${this.palette[idx % this.palette.length]}"></span>
                <span class="val">${this._c(i.count)}명 (${pct}%)${exempt}</span>
            </div>`;
        }).join('');
        $(sel).html(html);
    }

    /** 납부경로 막대 클릭 → 당월 해당 경로 회원목록 모달 */
    async _openPayMembers($row) {
        const source = String($row.data('source') || '');
        const label = String($row.data('label') || source);
        if (!source) return;

        try {
            const res = await $.ajax({ url: '/adm/ajax/stat/cash/pay-members', type: 'get', data: { source } });
            if (!res.ok) return;
            const rows = res.data || [];
            const tblId = 'cc-pay-members-tbl';
            const html = `<div style="padding:4px 2px;"><table id="${tblId}" class="table table-sm table-bordered display" style="width:100%;"></table></div>`;
            $j.Ui.JBModal.html('cc-pay-members-modal', html, `당월 회비 · ${label} · ${this._c(rows.length)}명`, { width: '620px' });

            if (this.$payMemTable) { try { this.$payMemTable.destroy(); } catch (e) { /* noop */ } this.$payMemTable = null; }
            if (!document.getElementById(tblId)) return;

            this.$payMemTable = new DataTable(`#${tblId}`, {
                data: rows,
                columns: [
                    { data: 'mem_name', title: '이름', render: (v, t, r) => this._nameCell(v, r) },
                    { data: 'mem_phone', title: '연락처', render: (v) => Util.escapeHtml(v || '-') },
                    { data: 'mem_car_type', title: '장비', render: (v) => Util.escapeHtml(v || '-') },
                    { data: 'amount', title: '회비', className: 'num', render: (v) => this._c(v) },
                    {
                        data: 'is_paid', title: '수납',
                        render: (v) => Number(v)
                            ? '<span class="badge badge-success">수납</span>'
                            : '<span class="badge badge-secondary">무상</span>',
                    },
                ],
                order: [],          // 서버 정렬(회비 큰 순) 유지
                pageLength: 10,
                lengthChange: false,
                searching: true,
                info: false,
                autoWidth: false,
                language: { emptyTable: '없음', search: '검색:', zeroRecords: '없음' },
            });
        } catch (e) {
            console.error('납부경로 회원목록 로드 실패', e);
        }
    }

    _fmtMonth(mc) {
        const s = String(mc || '');
        return s.length === 6 ? `${s.slice(0, 4)}.${s.slice(4)}` : (s || '-');
    }

    _won(n) {
        n = Number(n || 0);
        const neg = n < 0; n = Math.abs(n);
        let s;
        if (n >= 1e8) s = (n / 1e8).toFixed(1) + '억';
        else if (n >= 1e4) s = Math.round(n / 1e4).toLocaleString() + '만';
        else s = n.toLocaleString();
        return (neg ? '-' : '') + s;
    }

    _c(n) { return Number(n || 0).toLocaleString(); }

    destroy() {
        if (this.$feeTable) { this.$feeTable.destroy(); this.$feeTable = null; }
        if (this.$flowTable) { this.$flowTable.destroy(); this.$flowTable = null; }
        if (this.$payMemTable) { this.$payMemTable.destroy(); this.$payMemTable = null; }
    }
}
